export const USER_TOKEN_KEY = 'user-token';
export const ZANGIA_TOKEN_KEY = '__user_sess';
export const ZANGIA_TOKEN_KEY_AUTO_LOGIN = '_AUTO_LOGIN';
/** sessionStorage: pending /salary-summary/result navigation after login from hero filter */
export const SALARY_SUMMARY_PENDING_NAV_KEY = 'salarySummaryPendingNavigate';

export const ZANGIA_LOGOS = [
  {
    href: 'https://academy.zangia.mn',
    src: '/images/logos/academy.svg',
    alt: 'zangia academy',
  },
  {
    href: 'https://audio.zangia.mn',
    src: '/images/logos/audio.svg',
    alt: 'zangia audio',
  },
  {
    href: 'https://training.zangia.mn',
    src: '/images/logos/training.svg',
    alt: 'zangia training',
  },
  {
    href: '/hr-magazine',
    src: '/images/logos/magazine.svg',
    alt: 'zangia hr magazine',
  },
  {
    href: 'https://testly.mn',
    src: '/images/logos/testly.svg',
    alt: 'testly',
  },
  {
    href: '/urso',
    src: '/images/logos/urso.png',
    alt: 'Urso',
  },
];